import { render } from "./HomeMenuComponent.vue?vue&type=template&id=12efce72&scoped=true"
import script from "./HomeMenuComponent.vue?vue&type=script&lang=js"
export * from "./HomeMenuComponent.vue?vue&type=script&lang=js"

import "./HomeMenuComponent.vue?vue&type=style&index=0&id=12efce72&lang=less&scoped=true"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-12efce72"]])

export default __exports__